function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.set-prototype-of.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import classNames from 'classnames';
import { Textarea } from './Textarea';
import styles from './LimitedTextarea.module.less';
export var LimitedTextarea = /*#__PURE__*/function (_Component) {
  _inherits(LimitedTextarea, _Component);

  var _super = _createSuper(LimitedTextarea);

  function LimitedTextarea(props) {
    var _this;

    _classCallCheck(this, LimitedTextarea);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var newValue = e.target.value;

      if (newValue.length > _this.props.maxLength) {
        return;
      }

      _this.setState({
        charCount: newValue.length
      });

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    });

    _this.state = {
      charCount: typeof props.value === 'string' ? props.value.length : 0
    };
    return _this;
  }

  _createClass(LimitedTextarea, [{
    key: "renderCharacterCounter",
    value: function renderCharacterCounter() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames([styles['limit-count'], _defineProperty({}, styles['limit-count-warning'], this.props.maxLength - this.state.charCount <= 10)])
      }, this.props.maxLength - this.state.charCount);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea, _extends({}, this.props, {
        onChange: this.handleChange // Textarea must be full width to account for float right char count
        // layout.
        ,
        fullWidth: true
      })), this.renderCharacterCounter());
    }
  }]);

  return LimitedTextarea;
}(Component);

_defineProperty(LimitedTextarea, "defaultProps", {
  maxLength: 5000
});

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types'); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  LimitedTextarea.propTypes = {
    value: PropTypes.string,
    maxLength: PropTypes.number,
    onChange: PropTypes.func
  };
}